(function () {
  var root = document.getElementById(
    'PetmedAll-petmed-all'
  );

  if (
    !root ||
    root.dataset.petmedInitialised === 'true'
  ) {
    return;
  }

  root.dataset.petmedInitialised = 'true';

  var items = Array.prototype.slice.call(
    root.querySelectorAll(
      '[data-petmed-item]'
    )
  );

  var chips = Array.prototype.slice.call(
    root.querySelectorAll(
      '[data-petmed-filter]'
    )
  );

  var countElement = root.querySelector(
    '[data-petmed-count]'
  );

  var emptyElement = root.querySelector(
    '[data-petmed-empty]'
  );

  var resetButton = root.querySelector(
    '[data-petmed-reset]'
  );

  var toggleButton = root.querySelector(
    '[data-petmed-toggle]'
  );

  var sidebar = root.querySelector(
    '[data-petmed-sidebar]'
  );

  var categoryBannersContainer =
    root.querySelector(
      '[data-petmed-category-banners]'
    );

  var categoryBanners =
    Array.prototype.slice.call(
      root.querySelectorAll(
        '[data-petmed-category-banner]'
      )
    );

  var active = {
    cat: [],
    brand: []
  };

  function updateCategoryBanner() {
    var selectedCategory =
      active.cat.length === 1
        ? active.cat[0]
        : '';

    categoryBanners.forEach(
      function (banner) {
        var isActive =
          banner.getAttribute(
            'data-petmed-category-banner'
          ) === selectedCategory;

        banner.hidden = !isActive;
      }
    );

    if (categoryBannersContainer) {
      categoryBannersContainer.hidden =
        !selectedCategory;
    }
  }

  function applyFilters() {
    var visible = 0;

    items.forEach(function (item) {
      var collections = (
        item.getAttribute(
          'data-collections'
        ) || ''
      )
        .trim()
        .split(/\s+/)
        .filter(Boolean);

      var categoryMatches =
        active.cat.length === 0 ||
        active.cat.some(function (handle) {
          return collections.indexOf(
            handle
          ) !== -1;
        });

      var brandMatches =
        active.brand.length === 0 ||
        active.brand.some(function (handle) {
          return collections.indexOf(
            handle
          ) !== -1;
        });

      var show =
        categoryMatches &&
        brandMatches;

      item.classList.toggle(
        'is-hidden',
        !show
      );

      if (show) {
        visible++;
      }
    });

    if (countElement) {
      countElement.textContent = visible;
    }

    if (emptyElement) {
      emptyElement.hidden =
        visible !== 0;
    }

    updateCategoryBanner();
  }

  chips.forEach(function (chip) {
    chip.addEventListener(
      'click',
      function () {
        var group = chip.getAttribute(
          'data-group'
        );

        var value = chip.getAttribute(
          'data-value'
        );

        if (group === 'cat') {
          var alreadySelected =
            active.cat.length === 1 &&
            active.cat[0] === value;

          active.cat = alreadySelected
            ? []
            : [value];

          chips.forEach(
            function (otherChip) {
              if (
                otherChip.getAttribute(
                  'data-group'
                ) === 'cat'
              ) {
                otherChip.setAttribute(
                  'aria-pressed',
                  (
                    !alreadySelected &&
                    otherChip.getAttribute(
                      'data-value'
                    ) === value
                  )
                    ? 'true'
                    : 'false'
                );
              }
            }
          );
        } else {
          var list = active[group];
          var position =
            list.indexOf(value);

          if (position === -1) {
            list.push(value);

            chip.setAttribute(
              'aria-pressed',
              'true'
            );
          } else {
            list.splice(position, 1);

            chip.setAttribute(
              'aria-pressed',
              'false'
            );
          }
        }

        applyFilters();
      }
    );
  });

  if (resetButton) {
    resetButton.addEventListener(
      'click',
      function () {
        active.cat = [];
        active.brand = [];

        chips.forEach(function (chip) {
          chip.setAttribute(
            'aria-pressed',
            'false'
          );
        });

        applyFilters();
      }
    );
  }

  if (toggleButton && sidebar) {
    toggleButton.addEventListener(
      'click',
      function () {
        var isOpen =
          sidebar.classList.toggle(
            'is-open'
          );

        toggleButton.setAttribute(
          'aria-expanded',
          isOpen
            ? 'true'
            : 'false'
        );
      }
    );
  }

  function formatMoney(cents) {
    var moneyFormat =
      root.getAttribute(
        'data-money-format'
      ) ||
      '€{{amount_with_comma_separator}}';

    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney ===
        'function'
    ) {
      return window.Shopify.formatMoney(
        Number(cents || 0),
        moneyFormat
      );
    }

    return (
      '€' +
      (Number(cents || 0) / 100)
        .toFixed(2)
        .replace('.', ',')
    );
  }

  function getShopifyRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function refreshCartInterfaces() {
    document.dispatchEvent(
      new CustomEvent(
        'cart:refresh',
        {
          bubbles: true
        }
      )
    );

    document.dispatchEvent(
      new CustomEvent(
        'cart:updated',
        {
          bubbles: true
        }
      )
    );

    fetch(
      getShopifyRoot() + 'cart.js',
      {
        headers: {
          Accept: 'application/json'
        }
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Errore caricamento carrello'
          );
        }

        return response.json();
      })
      .then(function (cart) {
        document
          .querySelectorAll(
            [
              '[data-cart-count]',
              '.cart-count-bubble span',
              '.cart-count'
            ].join(',')
          )
          .forEach(function (element) {
            element.textContent =
              cart.item_count;
          });
      })
      .catch(function () {});
  }

  items.forEach(function (card) {
    var variantSelect =
      card.querySelector(
        '[data-petmed-variant]'
      );

    var singleVariant =
      card.querySelector(
        '[data-petmed-variant-single]'
      );

    var quantityInput =
      card.querySelector(
        '[data-petmed-qty]'
      );

    var minusButton =
      card.querySelector(
        '[data-petmed-minus]'
      );

    var plusButton =
      card.querySelector(
        '[data-petmed-plus]'
      );

    var addButton =
      card.querySelector(
        '[data-petmed-add]'
      );

    var priceElement =
      card.querySelector(
        '[data-petmed-price]'
      );

    var compareElement =
      card.querySelector(
        '[data-petmed-compare]'
      );

    var stockDot =
      card.querySelector(
        '[data-petmed-stock-dot]'
      );

    var stockText =
      card.querySelector(
        '[data-petmed-stock-text]'
      );

    var message =
      card.querySelector(
        '[data-petmed-message]'
      );

    var productImage =
      card.querySelector(
        '[data-petmed-product-image]'
      );

    function getVariantData() {
      if (variantSelect) {
        var option =
          variantSelect.options[
            variantSelect.selectedIndex
          ];

        if (!option) {
          return null;
        }

        return {
          id: option.value,

          price: Number(
            option.getAttribute(
              'data-price'
            ) || 0
          ),

          compare: Number(
            option.getAttribute(
              'data-compare'
            ) || 0
          ),

          available:
            option.getAttribute(
              'data-available'
            ) === 'true',

          image:
            option.getAttribute(
              'data-image'
            ) || ''
        };
      }

      if (singleVariant) {
        return {
          id: singleVariant.value,

          price: Number(
            singleVariant.getAttribute(
              'data-price'
            ) || 0
          ),

          compare: Number(
            singleVariant.getAttribute(
              'data-compare'
            ) || 0
          ),

          available:
            singleVariant.getAttribute(
              'data-available'
            ) === 'true',

          image: ''
        };
      }

      return null;
    }

    function updateVariantUi() {
      var variant =
        getVariantData();

      if (!variant) {
        return;
      }

      if (priceElement) {
        priceElement.textContent =
          formatMoney(
            variant.price
          );
      }

      if (compareElement) {
        if (
          variant.compare &&
          variant.compare >
            variant.price
        ) {
          compareElement.hidden =
            false;

          compareElement.textContent =
            formatMoney(
              variant.compare
            );
        } else {
          compareElement.hidden =
            true;

          compareElement.textContent =
            '';
        }
      }

      if (stockDot) {
        stockDot.classList.toggle(
          'is-soldout',
          !variant.available
        );
      }

      if (stockText) {
        stockText.textContent =
          variant.available
            ? 'Disponibile'
            : 'Esaurito';
      }

      if (addButton) {
        addButton.disabled =
          !variant.available;

        addButton.textContent =
          variant.available
            ? 'Aggiungi al carrello'
            : 'Esaurito';
      }

      if (
        productImage &&
        variant.image
      ) {
        productImage.src =
          variant.image;

        productImage.srcset = '';
      }

      if (message) {
        message.textContent = '';
      }
    }

    if (variantSelect) {
      variantSelect.addEventListener(
        'change',
        updateVariantUi
      );
    }

    if (
      minusButton &&
      quantityInput
    ) {
      minusButton.addEventListener(
        'click',
        function () {
          quantityInput.value =
            Math.max(
              1,
              parseInt(
                quantityInput.value ||
                  '1',
                10
              ) - 1
            );
        }
      );
    }

    if (
      plusButton &&
      quantityInput
    ) {
      plusButton.addEventListener(
        'click',
        function () {
          quantityInput.value =
            Math.max(
              1,
              parseInt(
                quantityInput.value ||
                  '1',
                10
              ) + 1
            );
        }
      );
    }

    if (quantityInput) {
      quantityInput.addEventListener(
        'change',
        function () {
          quantityInput.value =
            Math.max(
              1,
              parseInt(
                quantityInput.value ||
                  '1',
                10
              )
            );
        }
      );
    }

    if (addButton) {
      addButton.addEventListener(
        'click',
        function () {
          var variant =
            getVariantData();

          if (
            !variant ||
            !variant.available ||
            addButton.disabled
          ) {
            return;
          }

          var quantity =
            Math.max(
              1,
              parseInt(
                quantityInput
                  ? quantityInput.value
                  : '1',
                10
              )
            );

          addButton.disabled = true;

          addButton.textContent =
            'Aggiungo...';

          if (message) {
            message.textContent = '';
          }

          fetch(
            getShopifyRoot() +
              'cart/add.js',
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json',

                Accept:
                  'application/json'
              },

              body: JSON.stringify({
                items: [
                  {
                    id: Number(
                      variant.id
                    ),

                    quantity: quantity
                  }
                ]
              })
            }
          )
            .then(function (
              response
            ) {
              if (!response.ok) {
                return response
                  .json()
                  .then(function (
                    error
                  ) {
                    throw error;
                  });
              }

              return response.json();
            })
            .then(function () {
              addButton.textContent =
                'Aggiunto al carrello';

              if (message) {
                message.textContent =
                  'Prodotto aggiunto correttamente.';
              }

              refreshCartInterfaces();

              window.setTimeout(
                function () {
                  updateVariantUi();
                },
                1300
              );
            })
            .catch(function (
              error
            ) {
              addButton.disabled =
                false;

              addButton.textContent =
                'Riprova';

              if (message) {
                message.textContent =
                  error &&
                  error.description
                    ? error.description
                    : 'Impossibile aggiungere il prodotto.';
              }

              window.setTimeout(
                function () {
                  updateVariantUi();
                },
                1800
              );
            });
        }
      );
    }

    updateVariantUi();
  });

  function preselectFromUrl() {
    var values = [];

    try {
      var parameters =
        new URLSearchParams(
          window.location.search
        );

      [
        'filter',
        'f',
        'cat',
        'brand'
      ].forEach(function (key) {
        var value =
          parameters.get(key);

        if (value) {
          values =
            values.concat(
              value.split(',')
            );
        }
      });
    } catch (error) {}

    if (window.location.hash) {
      values.push(
        window.location.hash.replace(
          '#',
          ''
        )
      );
    }

    values = values
      .map(function (value) {
        return value
          .trim()
          .toLowerCase();
      })
      .filter(Boolean);

    if (!values.length) {
      return;
    }

    chips.forEach(function (chip) {
      var filterValue = (
        chip.getAttribute(
          'data-value'
        ) || ''
      ).toLowerCase();

      if (
        values.indexOf(
          filterValue
        ) === -1
      ) {
        return;
      }

      var group =
        chip.getAttribute(
          'data-group'
        );

      var actualValue =
        chip.getAttribute(
          'data-value'
        );

      if (group === 'cat') {
        if (
          active.cat.length === 0
        ) {
          active.cat = [
            actualValue
          ];

          chip.setAttribute(
            'aria-pressed',
            'true'
          );
        }
      } else if (
        active[group].indexOf(
          actualValue
        ) === -1
      ) {
        active[group].push(
          actualValue
        );

        chip.setAttribute(
          'aria-pressed',
          'true'
        );
      }
    });
  }

  preselectFromUrl();
  applyFilters();
})();